import { AccountsContext } from 'context/accounts/AccountsContext';
import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { Button, Link, LocaleContext } from 'shared';
import { Account } from 'store/api/types';
import { getEnvironmentVar } from 'utils';

import { Header as HeaderBase, HeaderActions, HeaderTitle } from './Header.styles';
import { HeaderProps } from './Header.types';

export const Header = withRouter(({ location, email }: HeaderProps) => {
  const localeContext = useContext(LocaleContext);
  const accountsContext = useContext(AccountsContext);
  const activeAccount = accountsContext.activeAccount as Account;

  const renderHeaderTitle = () => (
    <HeaderTitle>{localeContext.formatMessage({ id: 'HEADER.FOR-DEVELOPERS' })}</HeaderTitle>
  );

  if (!activeAccount) {
    return null;
  }

  return (
    <HeaderBase
      active={location.pathname}
      links={[
        {
          label: localeContext.formatMessage({ id: 'DASHBOARD.APPLICATIONS' }),
          url: `/${activeAccount.uuid}/dashboard`,
        },
        {
          external: true,
          label: localeContext.formatMessage({ id: 'SIDEBAR.DOCUMENTATION' }),
          url: `${getEnvironmentVar('REACT_APP_SPA_URL')}documentation/sandbox`,
        },
        {
          label: localeContext.formatMessage({ id: 'SIDEBAR.ACCOUNT-DETAILS' }),
          url: `/${activeAccount.uuid}/account`,
        },
      ]}
      title={renderHeaderTitle()}
    >
      {() => (
        <HeaderActions>
          <span>{email}</span>
          <Button type="leading" as={Link} {...{ url: '/logout' }} className="header__logout">
            {localeContext.formatMessage({ id: 'HEADER.LOGOUT' })}
          </Button>
        </HeaderActions>
      )}
    </HeaderBase>
  );
});
